<template>
  <div class="render">
    <div v-if="!this.$store.getters['user/getUserFields'].is_admin">
      Вы не администратор, авторизируйтесь как администратор!
    </div>
    <template v-else>
      <div v-if="if_main" class="content_table">
        <div class="top">
          <h1>Пользователи</h1>
        </div>
        <FilterCustom
          @updateFilter="onUpdateFilter"
          :visible="{
            phone: true,
            nickname: true,
            maska: '###########',
            visible: true,
            managerVisible: true,
          }"
        />
        <Table
          :page_type="'users_adimin'"
          :items="action_items"
          :loading="loading"
          :perPage="perPage"
          :server="false"
          :hideselect="true"
          :callback_view="viewUser"
          @user_view="viewUser"
          :headers="users_table.headers"
          :data="users_table.filterData"
        />
      </div>

      <div v-if="!if_main">
        <div class="top">
          <div @click="if_main = true" class="vback">Назад</div>
          <h1>Пользователь: {{ user_login }}</h1>
          <div class="user-card-actions">
          <v-btn v-if="showAdminLk" class="admin-lk-entry" depressed outlined :loading="enteringUser" :disabled="balanceLoading || !user_login" @click="enterUser">
            <v-icon left size="18">mdi-login</v-icon>
            Войти в ЛК
          </v-btn>

          <div @click="saveUser" class="cashup mt-0">Сохранить</div>
          </div>
        </div>
        <div class="content">
          <div class="left">
            <div class="inform">
              <v-overlay :value="balanceLoading" absolute opacity="0.08">
                <v-progress-circular
                  indeterminate
                  size="48"
                  width="4"
                  color="#4B5EFF"
                />
              </v-overlay>
              <div class="balance w100p">
                <div class="title">Баланс</div>
                <div class="num">{{ user_balance }} р.</div>
              </div>
              <div class="balance w100p">
                <div class="title">Минуты</div>
                <div class="num">{{ user_minutes }} мин.</div>
              </div>

              <div class="balance input">
                <div class="title">1 СМС</div>
                <div class="num">
                  <v-text-field
                    v-model="price_sms"
                    placeholder="Стоимость"
                    type="number"
                  ></v-text-field>
                </div>
              </div>

              <div class="balance input">
                <div class="title">1 входящий звонок (мин.)</div>
                <div class="num">
                  <v-text-field
                    v-model="price_incoming"
                    placeholder="Стоимость"
                    type="number"
                  ></v-text-field>
                </div>
              </div>

              <div class="balance input">
                <div class="title">Цена за скор контакта</div>
                <div class="num">
                  <v-text-field
                    v-model="price_score"
                    placeholder="Стоимость"
                    type="number"
                  ></v-text-field>
                </div>
              </div>
              <div class="balance input">
                <div class="title">Цена 1 минуты</div>
                <div class="num">
                  <v-text-field
                    v-model="price_minute"
                    placeholder="Стоимость"
                    type="number"
                  ></v-text-field>
                </div>
              </div>
            </div>
            <div class="useradmn_info mt-6">
              <v-expansion-panels class="user-tariffs-panels">
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    Тарифы пользователя по транкам
                  </v-expansion-panel-header>

                  <v-expansion-panel-content>
                    <div v-if="markupPreviewError" class="markup-preview-error">
                      {{ markupPreviewError }}
                    </div>

                    <div
                      v-else-if="!markupPreview"
                      class="markup-preview-loading"
                    >
                      <span>Загрузка расчёта</span>

                      <span class="loading-dots">
                        <span>.</span>
                        <span>.</span>
                        <span>.</span>
                        <span>.</span>
                        <span>.</span>
                      </span>
                    </div>

                    <div v-else>
                      <div class="markup-preview-summary">
                        <span>
                          Сервис: <b>{{ markupPreview.service }}</b>
                        </span>
                      </div>
                      <div class="user-tariffs-actions">
                        <v-btn
                          outlined
                          elevation="0"
                          class="user-tariffs-save-button"
                          :loading="userTariffsSaving"
                          :disabled="userTariffsSaving"
                          @click="saveUserTariffs"
                        >
                          <v-icon left small> mdi-content-save-outline </v-icon>

                          Сохранить тарифы
                        </v-btn>

                        <span
                          v-if="userTariffsMessage"
                          class="user-tariffs-success"
                        >
                          {{ userTariffsMessage }}
                        </span>

                        <span
                          v-if="userTariffsSaveError"
                          class="user-tariffs-save-error"
                        >
                          {{ userTariffsSaveError }}
                        </span>
                      </div>

                      <v-expansion-panels accordion class="trunk-tariff-panels">
                        <v-expansion-panel
                          v-for="item in markupPreview.tariffs"
                          :key="item.trunk"
                        >
                          <v-expansion-panel-header
                            :class="{
                              'trunk-panel-header--active': item.active,
                            }"
                          >
                            <div class="trunk-tariff-header">
                              <span class="trunk-tariff-name">
                                {{ item.trunk }}
                              </span>

                              <span
                                v-if="item.active"
                                class="trunk-active-badge"
                              >
                                <span class="trunk-active-dot"></span>
                                Используется
                              </span>

                              <v-icon small color="#7b8494">
                                mdi-arrow-right
                              </v-icon>

                              <span class="trunk-tariff-price-label">
                                Цена номера
                              </span>

                              <b class="trunk-tariff-price">
                                {{ item.number.price }} ₽
                              </b>
                            </div>
                          </v-expansion-panel-header>

                          <v-expansion-panel-content>
                            <div class="markup-preview-number">
                              <div>
                                Минимальная цена:
                                <b>{{ item.number.cost }} ₽</b> · Стандартная
                                цена:
                                <b>{{ item.number.standard }} ₽</b>
                              </div>

                              <v-btn-toggle
                                v-model="item.number.mode"
                                mandatory
                                class="tariff-mode-toggle"
                              >
                                <v-btn
                                  small
                                  value="standard"
                                  class="tariff-mode-button"
                                >
                                  Стандартная
                                </v-btn>

                                <v-btn
                                  small
                                  value="individual"
                                  class="tariff-mode-button"
                                >
                                  Индивидуальная
                                </v-btn>
                              </v-btn-toggle>

                              <div
                                v-if="item.number.mode === 'individual'"
                                class="tariff-individual-field"
                              >
                                <span class="tariff-individual-label">
                                  Индивидуальная цена номера
                                </span>

                                <v-text-field
                                  v-model="item.number.individual"
                                  placeholder="Введите цену"
                                  suffix="₽"
                                  type="number"
                                  step="0.01"
                                  :min="item.number.cost"
                                  outlined
                                  dense
                                  hide-details
                                  class="tariff-individual-input"
                                ></v-text-field>
                              </div>
                            </div>

                            <div class="markup-preview-operators">
                              <div
                                v-for="(price, operator) in item.initiation"
                                :key="operator"
                                class="markup-preview-operator"
                              >
                                <div class="markup-preview-operator-title">
                                  {{ operatorLabels[operator] }}
                                </div>

                                <div class="markup-preview-operator-prices">
                                  Минимальная цена: <b>{{ price.cost }} ₽</b> ·
                                  Стандартная:
                                  <b>{{ price.standard }} ₽</b>
                                </div>

                                <v-btn-toggle
                                  v-model="price.mode"
                                  mandatory
                                  class="tariff-mode-toggle"
                                >
                                  <v-btn
                                    small
                                    value="standard"
                                    class="tariff-mode-button"
                                  >
                                    Стандартная
                                  </v-btn>

                                  <v-btn
                                    small
                                    value="individual"
                                    class="tariff-mode-button"
                                  >
                                    Индивидуальная
                                  </v-btn>
                                </v-btn-toggle>

                                <div
                                  v-if="price.mode === 'individual'"
                                  class="tariff-individual-field"
                                >
                                  <span class="tariff-individual-label">
                                    Индивидуальная цена
                                  </span>

                                  <v-text-field
                                    v-model="price.individual"
                                    placeholder="Введите цену"
                                    suffix="₽"
                                    type="number"
                                    step="0.01"
                                    :min="price.cost"
                                    outlined
                                    dense
                                    hide-details
                                    class="tariff-individual-input"
                                  ></v-text-field>
                                </div>
                              </div>
                            </div>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </div>

            <div class="useradmn_info mt-6">
              <p>Кастомный тариф:</p>
              <div class="flex">
                <div class="balance mr-5">
                  <div class="title">Сумма пополнения</div>
                  <div class="num">
                    <v-text-field
                      v-model="customTariff.sum"
                      placeholder="Стоимость тарифа"
                      type="number"
                    ></v-text-field>
                  </div>
                </div>
                <div class="balance mr-5">
                  <div class="title">Минуты</div>
                  <div class="num">
                    <v-text-field
                      v-model="customTariff.min"
                      placeholder="Минуты"
                      type="number"
                    ></v-text-field>
                  </div>
                </div>
                <div class="balance">
                  <div class="title">Стоимость 1 мин.</div>
                  <div class="num">
                    <v-text-field
                      v-model="resPriceCustomTariff"
                      placeholder="Цена минуты"
                      type="number"
                    ></v-text-field>
                  </div>
                </div>
              </div>
              <!--						<div  class="cashup btn_custom_tariff mt-0">Провести тариф</div>-->
              <div class="custom_tariff_save_message">
                <!--							<div @click="saveCustomTariffs" class="save mt-0 mr-0">Провести тариф</div>-->
                <div
                  @click="securityOfAdminActions('customTariffMinutes')"
                  class="save mt-0 mr-0"
                >
                  Провести тариф
                </div>
                <div v-if="statusCustomTariff === true" class="save_message">
                  Тариф прошел успешно!
                </div>
                <div
                  style="color: #de4040"
                  v-if="statusCustomTariff === false"
                  class="save_message"
                >
                  Недостаточно баланса пользователя!
                </div>
                <div
                  style="color: #de4040"
                  v-if="statusCustomTariff === 'noValid'"
                  class="save_message"
                >
                  Не верное заполнение формы!
                </div>
              </div>
            </div>
            <div class="useradmn_info mt-6">
              <p>Пополнение баланса пользователя:</p>
              <div class="flex">
                <div class="mr-5 w100p">
                  <div class="title">Коментарий к пополнению</div>
                  <div class="num">
                    <v-text-field
                      v-model="addBalanceUser.comment"
                      placeholder="Комментарий"
                      type="text"
                    ></v-text-field>
                  </div>
                </div>
                <div style="width: 275px">
                  <div class="title">Сумма пополнения</div>
                  <div class="num">
                    <v-text-field
                      v-model="addBalanceUser.sum"
                      placeholder="Сумма"
                      type="number"
                    ></v-text-field>
                  </div>
                </div>
              </div>
              <div class="custom_tariff_save_message">
                <div
                  @click="securityOfAdminActions('addBalanceUser')"
                  class="save mt-0 mr-0"
                >
                  Пополнить баланс
                </div>
                <div v-if="statusAddBalanceUser === true" class="save_message">
                  Средства поступили на счет!
                </div>
                <div
                  style="color: #de4040"
                  v-if="statusAddBalanceUser === false"
                  class="save_message"
                >
                  Ошибка при пополнении!
                </div>
                <div
                  style="color: #de4040"
                  v-if="statusAddBalanceUser === 'noValid'"
                  class="save_message"
                >
                  Не верное заполнение формы!
                </div>
              </div>
            </div>
            <div class="useradmn_info mt-6">
              <p>Оплата кастомной услуги:</p>
              <div class="flex">
                <div class="mr-5 w100p">
                  <div class="title">Название оплачиваемой услуги</div>
                  <div class="num">
                    <v-text-field
                      v-model="customService.name"
                      placeholder="Название тарифа"
                      type="text"
                    ></v-text-field>
                  </div>
                </div>
                <div class="">
                  <div class="title">Стоимость</div>
                  <div class="num">
                    <v-text-field
                      v-model="customService.price"
                      placeholder="Цена услуги"
                      type="number"
                    ></v-text-field>
                  </div>
                </div>
              </div>
              <div class="custom_tariff_save_message">
                <div
                  @click="securityOfAdminActions('customServices')"
                  class="save mt-0 mr-0"
                >
                  Списание за услугу
                </div>
                <div v-if="statusCustomService === true" class="save_message">
                  Средства за услугу списаны!
                </div>
                <div
                  style="color: #de4040"
                  v-if="statusCustomService === false"
                  class="save_message"
                >
                  Недостаточно баланса пользователя!
                </div>
                <div
                  style="color: #de4040"
                  v-if="statusCustomService === 'noValid'"
                  class="save_message"
                >
                  Не верное заполнение формы!
                </div>
              </div>
            </div>
            <div class="useradmn_info mt-7">
              <p>Оповестить этого пользователя:</p>
              <v-textarea
                class="my_textarea"
                name="input-7-1"
                auto-grow
                placeholder="Сообщение"
                v-model="massage_text"
              ></v-textarea>
              <p v-show="massage_sended" style="color: green">
                Сообщение отправлено
              </p>
              <p v-show="massage_novalid" style="color: red">
                Нельзя отправить пустое сообщение
              </p>
              <div @click="sendUserMassage" class="save mt-0">
                Добавить оповещение
              </div>
            </div>
          </div>
          <div class="right">
            <p>Статус пользователя:</p>
            <v-select
              v-model="user_status"
              :items="user_statuses"
              item-value="id"
              item-text="name"
            ></v-select>
            <v-checkbox
              v-model="active_client"
              color="#4B5EFF"
              label="Активный клиент"
            ></v-checkbox>
            <p>Псевдоним пользователя</p>
            <v-text-field
              v-model="user_nickname"
              placeholder="Псевдоним"
              type="text"
            ></v-text-field>
            <p>Ответственный менеджер</p>
            <v-select
              v-model="user_manager"
              :items="user_managers"
              item-value="id"
              item-text="name"
            ></v-select>
            <!-- <div class="useradmn_info mt-5">
						<p v-for="doc in user_docs" :key="doc.title">{{ doc.title }}:
							<b v-if="!doc.is_link">{{ doc.value }}</b>
							<a v-if="doc.is_link" target="_blank" :href="doc.value">{{ doc.value }}</a>
						</p>
					</div> -->
            <div class="useradmn_info mt-5 docs_block">
              <v-overlay :value="docsLoading" absolute opacity="0.08">
                <v-progress-circular
                  indeterminate
                  size="40"
                  width="4"
                  color="#4B5EFF"
                />
              </v-overlay>
              <p v-if="docsError" class="docs_error">{{ docsError }}</p>
              <div class="docs_header">
                <div class="docs_delete_all" @click="clearAllDocs">
                  <Icon name="trash" />
                  <span>Удалить все</span>
                </div>
              </div>
              <div
                v-if="docsLoaded && !docsLoading && user_docs.length === 0"
                class="docs_empty"
              >
                Пользователь не добавил документы
              </div>
              <div v-for="doc in user_docs" :key="doc.key" class="doc_row">
                <div class="doc_left">
                  <div class="doc_title">{{ doc.title }}</div>

                  <div v-if="docEditKey !== doc.key" class="doc_value">
                    <span v-if="!doc.is_link">{{ doc.value || '—' }}</span>
                    <a v-else target="_blank" :href="doc.value">
                      {{ doc.value }}
                    </a>
                  </div>

                  <div v-else class="doc_edit">
                    <v-text-field v-model="docEditValue" hide-details dense />
                  </div>
                </div>

                <div class="doc_actions">
                  <template v-if="docEditKey !== doc.key">
                    <span
                      v-if="!isDocProtected(doc.key)"
                      class="doc_icon edit"
                      @click="startEditDoc(doc)"
                      title="Редактировать"
                    >
                      <Icon name="edit" />
                    </span>

                    <span
                      v-if="!isDocProtected(doc.key)"
                      class="doc_icon trash"
                      @click="clearDoc(doc)"
                      title="Очистить"
                    >
                      <Icon name="trash" />
                    </span>
                  </template>

                  <template v-else>
                    <span
                      class="doc_icon"
                      @click="saveEditDoc"
                      title="Сохранить"
                    >
                      <Icon name="newOk" />
                    </span>

                    <span
                      class="doc_icon cancel"
                      @click="cancelEditDoc"
                      title="Отмена"
                    >
                      <Icon name="close" />
                    </span>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="bottom_admuser">
          <h2>Cписок транзакций</h2>
          <Table
            :page_type="'users_adimin_transactions'"
            :loading="false"
            :perPage="perPage"
            :server="false"
            :hideselect="true"
            :headers="users_payments_table.headers"
            :data="users_payments_table.data"
          />
        </div>
        <div class="bottom_admuser">
          <h2>История покупок минут</h2>
          <Table
            :page_type="'users_adimin_transactions'"
            :loading="false"
            :perPage="perPage"
            :server="false"
            :hideselect="true"
            :headers="user_tariffs_table.headers"
            :data="user_tariffs_table.data"
          />
        </div>
        <div class="bottom_admuser">
          <h2>История оплаченых услуг</h2>
          <Table
            :page_type="'users_adimin_transactions'"
            :loading="false"
            :perPage="perPage"
            :server="false"
            :hideselect="true"
            :headers="user_service_table.headers"
            :data="user_service_table.data"
          />
        </div>
        <FrameModalPopup
          :dialogShow="verificationForm.popup"
          @close="verificationForm.popup = false"
        >
          <div class="center">
            <div>
              <div class="block_center">
                <Icon name="warning" />
              </div>
              <div class="popup_text">
                {{ verificationForm.text }}
              </div>
            </div>
            <div class="my_btn add_modal" @click="requestCabinetUser()">
              Подтверждаю
            </div>
          </div>
        </FrameModalPopup>
      </div>
    </template>
  </div>
</template>
<script>
import Table from '../../components/Table/DataTable.vue';
import FilterCustom from '../../components/FilterMy.vue';
import FrameModalPopup from '@/components/Modal/FrameModalPopup';
import Icon from '@/components/SetIcon';
import moment from 'moment';

export default {
  components: {
    Table,
    FilterCustom,
    FrameModalPopup,
    Icon,
  },
  data() {
    return {
      showAdminLk: sessionStorage.getItem('showAdminLk') === '1',
      price_minute: 0,
      if_main: true,
      price_score: 0,
      user_login: '',
      enteringUser: false,
      massage_text: '',
      massage_sended: false,
      massage_novalid: false,
      filters: {},
      loading: true,
      price_incoming: 0,
      perPage: 10,
      tablist: 'all',
      edit_popup: false,
      price_number: 50,
      markupPreview: null,
      markupPreviewError: '',
      userTariffsSaving: false,
      userTariffsMessage: '',
      userTariffsSaveError: '',
      operatorLabels: {
        mts: 'МТС',
        beeline: 'Билайн',
        megafon: 'Мегафон',
        yota: 'Yota',
        t2: 'Т2',
        other: 'Остальные',
      },
      action_items: [{ title: 'Редакт.', action: 'user_view' }],
      users_table: {
        data: [],
        filterData: [],
        headers: [
          { text: 'Телефон', value: 'phone' },
          { text: 'Имя', value: 'nickname' },
          { text: 'Отв-ный', value: 'manager' },
          { text: 'Статус', value: 'user_status' },
          { text: 'Баланс', value: 'balance' },
          { text: 'Минуты', value: 'minutes' },
          { text: 'Цена вход.', value: 'price_incoming' },
          { text: 'Цена скор', value: 'price_score' },
          { text: 'Цена 1 мин.', value: 'price_pre_minute' },
          { text: 'Дата регистр.', value: 'created_at' },
          { text: 'Последняя автр.', value: 'last_auth' },
          { text: 'Действия', value: 'actions', sortable: false },
        ],
      },
      users_payments_table: {
        headers: [
          { text: '№', align: 'start', value: 'id' },
          { text: 'Тип операции', value: 'type' },
          { text: 'Сумма', value: 'sum' },
          { text: 'Дата обзвона', value: 'date' },
          { text: 'Статус', value: 'status' },
        ],
        data: this.$store.getters['user/getUserFields'].payments,
      },
      user_tariffs_table: {
        headers: [
          { text: '№', align: 'start', value: 'id' },
          { text: 'Стоимость', value: 'price' },
          { text: 'Куплено минут', value: 'minutes' },
          { text: 'Дата покупки', value: 'created_at' },
        ],
        data: [],
      },
      user_service_table: {
        headers: [
          { text: '№', align: 'start', value: 'id' },
          { text: 'Предоставленная услуга', value: 'service' },
          { text: 'Стоимость', value: 'price' },
          { text: 'Дата оплаты', value: 'created_at' },
        ],
        data: [],
      },
      user_statuses: [
        { id: 'unactive', name: 'Неакт.' },
        { id: 'waiting', name: 'На проверке' },
        { id: 'active', name: 'Активен' },
      ],
      user_managers: [
        { id: '', name: 'Не выбран' },
        { id: 'Александр', name: 'Александр Резник' },
        { id: 'Соня', name: 'Софья Поливанова' },
        { id: 'Аня', name: 'Анна Малеванова' },
        { id: 'Сергей', name: 'Сергей Михайлов' },
      ],
      user_status: 'active',
      price_ivr: 1,
      price_sms: 1,
      user_balance: 0,
      user_minutes: 0,
      user_docs: [],
      docsLoaded: false,
      docsLoading: false,
      balanceLoading: false,
      docEditKey: null,
      docEditValue: '',
      docsError: '',
      user_nickname: '',
      user_manager: '',
      active_client: true,
      filters_data_users: false,
      customTariff: {
        sum: '',
        min: '',
      },
      statusCustomTariff: '',
      customService: {
        name: '',
        price: '',
      },
      statusCustomService: '',
      addBalanceUser: {
        sum: '',
        comment: '',
      },
      statusAddBalanceUser: '',
      verificationForm: {
        text: '',
        caseVerification: '',
        popup: false,
      },
    };
  },
  mounted() {
    this.render();
  },
  watch: {
    user_login() {
      this.customTariff.sum = '';
      this.customTariff.min = '';
      this.statusCustomTariff = '';
      this.customService.name = '';
      this.customService.price = '';
      this.statusCustomService = '';
      this.addBalanceUser.sum = '';
      this.addBalanceUser.comment = '';
      this.statusAddBalanceUser = '';
    },
  },
  computed: {
    resPriceCustomTariff() {
      return +(this.customTariff.sum / this.customTariff.min).toFixed(2);
    },
  },
  methods: {
    enterUser() {
      if (!this.showAdminLk) return;
      if (this.enteringUser || this.balanceLoading || !this.user_login) return;
      const tab = window.open('about:blank', '_blank');
      if (!tab) { window.alert('Разрешите открытие новой вкладки'); return; }
      tab.opener = null;
      this.enteringUser = true;
      this.$http.post('/admin_users/login-as', { login: String(this.user_login) }, result => {
        this.enteringUser = false;
        if (!result || !/^adminlk_[a-f0-9]{64}$/.test(result.token || '')) {
          tab.close();
          window.alert((result && result.error) || 'Не удалось войти в ЛК');
          return;
        }
        if (!tab.closed) tab.location.replace('/bases#admin_lk=' + encodeURIComponent(result.token));
      });
    },
    render() {
      this.$http.post('/admin_users/list', {}, (result) => {
        // console.log(result)
        // console.log('FRONT price_minute=', this.price_minute);
        this.users_table.data = result.map((item) => {
          // console.log('🚀 -> render -> item:', moment(item.created_at).format('YYYY-MM-DD hh:mm:ss'))
          // let date = new Date(item.created_at)

          item.created_at = moment(item.created_at).format('YYYY-MM-DD');
          const pn = Number(item.price_number);
          item.price_number = Number.isFinite(pn) && pn > 0 ? pn : 50;
          return item;
        });
        this.loading = false;
        this.filterDataUsers();
      });
    },
    saveUserTariffs() {
      if (!this.markupPreview || !Array.isArray(this.markupPreview.tariffs)) {
        this.userTariffsSaveError = 'Нет тарифов для сохранения';
        return;
      }

      this.userTariffsSaving = true;
      this.userTariffsMessage = '';
      this.userTariffsSaveError = '';

      this.$http.post(
        '/admin_users/save-user-tariffs',
        {
          login: this.user_login,
          tariffs: this.markupPreview.tariffs,
        },
        (result) => {
          this.userTariffsSaving = false;

          if (result && result.success) {
            this.userTariffsMessage = `Сохранено транков: ${result.saved}`;
            window.location.reload();
            return;
          }

          this.userTariffsSaveError =
            result && result.error
              ? result.error
              : 'Не удалось сохранить тарифы';
        },
      );
    },
    sendUserMassage() {
      if (this.massage_text) {
        this.massage_novalid = false;
        this.$http.post(
          '/admin_users/send_massage',
          {
            login: this.user_login,
            text: this.massage_text,
          },
          (result) => {
            if (result) {
              this.massage_text = '';
              this.massage_sended = true;
            } else {
              alert('Упс! Что-то пошло не так');
            }
          },
        );
      } else {
        this.massage_novalid = true;
      }
    },
    saveUser() {
      this.$http.post(
        '/admin_users/save',
        {
          login: this.user_login,
          user_status: this.user_status,
          price_ivr: this.price_ivr,
          price_sms: this.price_sms,
          nickname: this.user_nickname,
          manager: this.user_manager,
          admin_visible: this.active_client,
          price_number: this.price_number,
          price_incoming: this.price_incoming,
          price_score: this.price_score,
          price_minute: this.price_minute,
        },
        (result) => {
          if (result) {
            this.if_main = true;
            this.render();
          }
        },
      );
    },
    startEditDoc(doc) {
      this.docsError = '';
      this.docEditKey = doc.key;
      this.docEditValue = doc.value || '';
    },

    cancelEditDoc() {
      this.docEditKey = null;
      this.docEditValue = '';
    },

    saveEditDoc() {
      this.docsError = '';
      if (!this.docEditKey) return;

      this.$http.post(
        '/admin_users/docs/set',
        {
          login: this.user_login,
          key: this.docEditKey,
          value: this.docEditValue,
        },
        (r) => {
          if (!r?.ok) {
            this.docsError = 'Не удалось сохранить';
            return;
          }
          const d = this.user_docs.find((x) => x.key === this.docEditKey);
          if (d) d.value = this.docEditValue;

          this.cancelEditDoc();
        },
      );
    },

    clearDoc(doc) {
      if (this.isDocProtected(doc.key)) {
        this.docsError = 'Это поле нельзя удалить';
        return;
      }
      this.docsError = '';
      this.$http.post(
        '/admin_users/docs/del',
        {
          login: this.user_login,
          key: doc.key,
        },
        (r) => {
          if (!r?.ok) {
            this.docsError = 'Не удалось удалить';
            return;
          }
          this.user_docs = this.user_docs.filter((x) => x.key !== doc.key);
          if (this.docEditKey === doc.key) this.cancelEditDoc();
        },
      );
    },
    isDocProtected(key) {
      const protectedKeys = [
        'type_user',
        'type_organization',
        'company_inn_file',
        'company_solution',
        'company_file',
        'pasport_one',
        'pasport_two',
        'photo_passport_person',
        'company_order',
      ];
      return protectedKeys.includes(key);
    },
    clearAllDocs() {
      this.docsError = '';
      this.$http.post(
        '/admin_users/docs/clear_all',
        { login: this.user_login },
        (r) => {
          if (!r?.ok) {
            this.docsError = 'Не удалось удалить документы';
            return;
          }
          this.user_docs = [];
          this.cancelEditDoc();
        },
      );
    },
    viewUser(item) {
      let login = item.phone;
      this.markupPreview = null;
      this.userTariffsSaving = false;
      this.userTariffsMessage = '';
      this.userTariffsSaveError = '';
      this.markupPreviewError = '';
      this.user_docs = [];
      this.cancelEditDoc();
      this.docsError = '';
      this.docsLoading = true;
      this.balanceLoading = true;
      this.docsLoaded = false;
      this.user_balance = null;
      this.user_minutes = null;
      this.$http.post(
        '/admin_users/getone',
        {
          login: login,
        },
        (result) => {
          // console.log(result, '=======================================')
          this.users_payments_table.data = result.payments.map((item) => {
            const date = new Date(item.date);
            item.date = `${date.getDate().toString().padStart(2, '0')}.${(
              date.getMonth() + 1
            )
              .toString()
              .padStart(2, '0')}.${date.getFullYear()}`;
            return item;
          });
          this.user_balance = result.balance;
          this.user_minutes = result.minutes;
          this.price_ivr = result.price_ivr;
          this.price_sms = result.price_sms;
          this.user_status = result.user_status;
          this.user_login = result.login;
          this.$http.post(
            '/admin_users/get-user-tariffs',
            {
              login: result.login,
            },
            (preview) => {
              if (preview && Array.isArray(preview.tariffs)) {
                this.markupPreview = preview;
                this.markupPreviewError = '';
                return;
              }

              this.markupPreview = null;
              this.markupPreviewError =
                preview && preview.error
                  ? preview.error
                  : 'Не удалось загрузить тарифы';
            },
          );
          this.user_nickname = result.nickname;
          this.user_manager = result.manager;
          this.active_client = result.admin_visible;
          const pn = Number(result.price_number);
          this.price_number = Number.isFinite(pn) && pn > 0 ? pn : 50;
          this.price_incoming = Number(result.price_incoming) || 0;
          this.price_score = Number(result.price_score) || 0;
          this.price_minute = Number(result.price_minute) || 0;
          let user_docs_translete = {
            type_user: 'Тип контрагента',
            type_organization: 'Форма организации',
            company_name: 'Название компании',
            company_inn: 'ОГРН',
            company_inn_file: 'Cвидетельство ИНН/ОГРН',
            company_solution: 'Приказ или решение о назначении',
            company_order: 'Приказ о назначении ген. дир.',
            company_file: 'Карточка компании',
            pasport_one: 'Первая страница паспорта',
            pasport_two: 'Вторая страница паспорта',
            photo_passport_person: 'Фото паспорта в руках',
            email: 'Email',

            // Новые:
            inn: 'ИНН',
            kpp: 'КПП',
            ogrn: 'ОГРН ООО',
            ogrnip: 'ОГРН ИП',
            r_s: 'Расчётный счёт',
            kor_s: 'Корр. счёт',
            bik: 'БИК',
            bank: 'Банк',
            address: 'Юрид. адрес',
          };
          this.user_docs = [];
          for (let e in result.user_docs) {
            this.user_docs.push({
              key: e,
              title: user_docs_translete[e],
              value: result.user_docs[e],
              is_link:
                e === 'company_file' ||
                e === 'pasport_one' ||
                e === 'pasport_two' ||
                e === 'company_inn_file' ||
                e === 'company_solution' ||
                e === 'company_order' ||
                e === 'photo_passport_person',
            });
          }
          this.docsLoading = false;
          this.balanceLoading = false;
          this.docsLoaded = true;
        },
      );
      this.if_main = false;

      this.$http.post(
        '/admin_users/get_table_service',
        {
          login: login,
        },
        (result) => {
          result.map((item, inx) => (item.id = inx + 1));
          this.user_service_table.data = result.map((item) => {
            const date = new Date(item.created_at);
            item.created_at = `${date.getDate().toString().padStart(2, '0')}.${(
              date.getMonth() + 1
            )
              .toString()
              .padStart(2, '0')}.${date.getFullYear()} ${date
              .getHours()
              .toString()
              .padStart(2, '0')}:${date
              .getMinutes()
              .toString()
              .padStart(2, '0')}`;
            return item;
          });
        },
      );
      this.$http.post(
        '/admin_users/get_table_tarifs',
        {
          login: login,
        },
        (result) => {
          result.map((item, inx) => (item.id = inx + 1));
          this.user_tariffs_table.data = result.map((item) => {
            const date = new Date(item.created_at);
            item.created_at = `${date.getDate().toString().padStart(2, '0')}.${(
              date.getMonth() + 1
            )
              .toString()
              .padStart(2, '0')}.${date.getFullYear()} ${date
              .getHours()
              .toString()
              .padStart(2, '0')}:${date
              .getMinutes()
              .toString()
              .padStart(2, '0')}`;
            return item;
          });
        },
      );
    },
    onUpdateFilter(new_filter) {
      this.filters_data_users = new_filter;

      this.filterDataUsers();
    },
    filterDataUsers() {
      let newData = this.users_table.data;
      if (this.filters_data_users.search) {
        newData = newData.filter((user) =>
          user.phone.includes(this.filters_data_users.search),
        );
      }
      if (this.filters_data_users.searchNickname) {
        newData = newData.filter((user) => {
          if (user.nickname) {
            return user.nickname.includes(
              this.filters_data_users.searchNickname,
            );
          } else {
            return false;
          }
        });
      }

      if (this.filters_data_users.searchManager) {
        newData = newData.filter((user) => {
          if (user.manager) {
            return user.manager.includes(this.filters_data_users.searchManager);
          } else {
            return false;
          }
        });
      }
      if (this.filters_data_users.active_client) {
        newData = newData.filter((user) => user.admin_visible);
      }
      // console.log(newData)
      this.users_table.filterData = newData;
    },
    securityOfAdminActions(way) {
      this.verificationForm.text = '';
      this.verificationForm.caseVerification = '';
      switch (way) {
        case 'customTariffMinutes':
          if (this.customTariff.sum && this.customTariff.min) {
            this.statusCustomTariff = '';
            this.verificationForm.text = `Вы подтверждаете что хотите
						провести тариф пользователю ${this.user_login}.
						Ему будет начислено ${this.customTariff.min} минут и списано ${
              this.customTariff.sum
            } руб.
						После чего на счету пользователя будет ${
              +this.customTariff.min + +this.user_minutes
            } минут и
						${+this.user_balance - +this.customTariff.sum} руб.`;
            this.verificationForm.caseVerification = 'customTariffMinutes';
            this.verificationForm.popup = true;
          } else {
            this.statusCustomTariff = 'noValid';
          }
          break;
        case 'addBalanceUser':
          if (this.addBalanceUser.sum && this.addBalanceUser.comment) {
            this.statusAddBalanceUser = '';
            this.verificationForm.text = `Вы подтверждаете что хотите
						пополнить баланс пользователю ${this.user_login},
						на сумму ${this.addBalanceUser.sum} руб. с комментарием к пополнению "${
              this.addBalanceUser.comment
            }".
						После пополнения баланс пользователя составит ${
              +this.addBalanceUser.sum + +this.user_balance
            } руб.`;
            this.verificationForm.caseVerification = 'addBalanceUser';
            this.verificationForm.popup = true;
          } else {
            this.statusAddBalanceUser = 'noValid';
          }
          break;
        case 'customServices':
          if (this.customService.name && this.customService.price) {
            this.statusCustomService = '';
            this.verificationForm.text = `Вы подтверждаете что хотите
						списать средства с пользователя ${this.user_login},
						за услугу "${this.customService.name}" на сумму ${this.customService.price} руб.
						После чего на балансе клиента останется ${
              +this.user_balance - +this.customService.price
            } руб.`;
            this.verificationForm.caseVerification = 'customServices';
            this.verificationForm.popup = true;
          } else {
            this.statusCustomService = 'noValid';
          }
          break;
      }
    },
    requestCabinetUser() {
      this.verificationForm.popup = false;
      switch (this.verificationForm.caseVerification) {
        case 'customTariffMinutes':
          if (this.customTariff.sum && this.customTariff.min) {
            this.$http.post(
              '/admin_users/add_custom_tarif',
              {
                sum: this.customTariff.sum,
                min: this.customTariff.min,
                login: this.user_login,
              },
              (result) => {
                this.user_balance = +this.user_balance - +this.customTariff.sum;
                this.user_minutes = +this.user_minutes + +this.customTariff.min;
                this.statusCustomTariff = result;
                this.customTariff.sum = '';
                this.customTariff.min = '';
                //this.viewUser({phone: this.user_login})
              },
            );
          }
          break;
        case 'addBalanceUser':
          if (this.addBalanceUser.sum && this.addBalanceUser.comment) {
            this.$http.post(
              '/admin_users/add_user_balance',
              {
                sum: this.addBalanceUser.sum,
                comment: this.addBalanceUser.comment,
                login: this.user_login,
              },
              (result) => {
                this.user_balance =
                  +this.user_balance + +this.addBalanceUser.sum;
                this.statusAddBalanceUser = result;
                this.addBalanceUser.sum = '';
                this.addBalanceUser.comment = '';
                //this.viewUser({phone: this.user_login})
              },
            );
          }
          break;
        case 'customServices':
          if (this.customService.name && this.customService.price) {
            this.$http.post(
              '/admin_users/add_user_service',
              {
                name: this.customService.name,
                price: this.customService.price,
                login: this.user_login,
              },
              (result) => {
                this.user_balance =
                  +this.user_balance - +this.customService.price;
                this.statusCustomService = result;
                this.customService.name = '';
                this.customService.price = '';
                //this.viewUser({phone: this.user_login})
              },
            );
          }
          break;
      }
    },
  },
};
</script>
<style scoped>
.user-card-actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-left: auto;
}

.user-card-actions .cashup,
.user-card-actions .admin-lk-entry.v-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: 150px;
  height: 46px;
  margin: 0;
  padding: 0 13px;
  font-size: 17px;
  font-weight: 600;
  line-height: 1.2;
}

.admin-lk-entry.v-btn {
  height: 44px;
  padding: 0 18px;
  color: #4b5eff;
  background: #fff;
  border: 1px solid #dce0ff;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: normal;
  text-transform: none;
}

.admin-lk-entry.v-btn:hover {
  background: #f4f5ff;
  border-color: #4b5eff;
}

::v-deep .v-data-table th:nth-child(4),
::v-deep .v-data-table td:nth-child(4) {
  width: 100px !important;
  max-width: 150px;
  white-space: nowrap;
}
.docs_empty {
  text-align: center;
  padding: 20px 0;
  color: #7b8794;
  font-weight: 500;
}
.docs_block {
  position: relative;
  min-height: 120px;
}
.docs_error {
  color: #de4040;
  font-weight: 500;
}
.docs_header {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 14px;
}

.docs_delete_all {
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  color: #de4040;
  padding: 6px 10px;
  border-radius: 6px;
  transition: 0.15s;
}

.docs_delete_all:hover {
  background: rgba(222, 64, 64, 0.08);
}

.docs_block {
  text-align: left;
}

.doc_row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 12px 0;
  border-bottom: 1px solid #f1f1f1;
  gap: 16px;
}

.doc_left {
  flex: 1;
  min-width: 0;
}

.doc_title {
  font-size: 13px;
  color: #7b8794;
  margin-bottom: 6px;
}

.doc_value {
  font-weight: 500;
  text-align: left;
  white-space: normal;
  word-break: break-word;
}

.doc_value a {
  word-break: break-all;
}

.doc_edit {
  max-width: 520px;
}

.doc_actions {
  flex: 0 0 auto;
  display: flex;
  gap: 12px;
  padding-top: 18px;
}

.doc_icon {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
}

p {
  text-align: left;
}
.custom_tariff_save_message {
  display: flex;
}
.block_center {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}
.save_message {
  height: 41px;
  margin: 0 0 0 35px;
  color: #1caf1c;
  padding: 8px;
}

.useradmn_info {
  background: #ffffff;
  padding: 24px;
  box-shadow: 0px 0px 2px rgb(0 0 0 / 6%), 0px 8px 24px rgb(0 0 0 / 10%);
  border-radius: 16px;
  height: -webkit-max-content;
  height: -moz-max-content;
  height: max-content;
}

.w100p {
  width: 100%;
}

.popup_text {
  text-align: center;
  margin-bottom: 25px;
}

.v_email_updated_massage {
  text-align: left;
  color: green;
}

.v_err_updated_massage {
  text-align: left;
  color: #b01111;
}

.mb26 {
  margin-bottom: 26px;
}

.top {
  margin-bottom: 24px;
}

.history_title {
  font-style: normal;
  font-weight: 800;
  font-size: 28px;
  line-height: 130%;
  color: #404247;
  text-align: left;
  margin-bottom: 8px;
}

.desc {
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 150%;
  color: #55575c;
  text-align: left;
  margin-bottom: 16px;
}

.ok {
  margin-top: 30px;
  background: #e8f7f4;
  width: 100%;
  border-radius: 8px;
  padding: 16px 24px;
}

.cashup {
  font-style: normal;
  font-weight: 600;
  font-size: 17px;
  line-height: 120%;
  color: #eee;
  background: #4b5eff;
  border-radius: 8px;
  padding: 13px;
  margin-top: 40px;
  cursor: pointer;
}

.btn_custom_tariff {
  width: max-content;
  margin-left: auto;
}

.history {
  margin: 8px auto 0 auto;
  font-style: normal;
  font-weight: 500;
  font-size: 17px;
  line-height: 120%;
  color: #00809c;
  cursor: pointer;
  position: relative;
  width: max-content;
}

.history:after {
  content: '';
  display: block;
  height: 1px;
  width: 100%;
  background: #00809c;
  position: absolute;
  bottom: -4px;
}

.save {
  background: #ffffff;
  border: 1px solid #4b5eff;
  border-radius: 8px;
  padding: 9px 20px;
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  margin-top: 16px;
  line-height: 110%;
  color: #2b2d33;
  max-width: max-content;
  cursor: pointer;
}

.top {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
}

.inform {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 16px;
  background: #ffffff;
  padding: 24px;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.06), 0 8px 24px rgba(0, 0, 0, 0.1);
  border-radius: 16px;
  position: relative;
}

.balance {
  width: auto;
}

.balance.input .v-input,
.balance.input .v-text-field {
  max-width: 200px;
}
@media (max-width: 900px) {
  .inform {
    grid-template-columns: 1fr;
  }
  .balance.w100p {
    grid-column: auto;
  }
}
.left .title {
  margin-bottom: 6px;
}
.balance.w100p {
  grid-column: 1 / -1;
}
.balance.input .num {
  font-weight: 600;
  font-size: 16px;
}
.left .num {
  font-weight: 800;
  font-size: 36px;
  line-height: 130%;
  color: #404247;
  text-align: left;
}

@media (max-width: 900px) {
  .inform {
    grid-template-columns: 1fr;
  }
  .balance.w100p {
    grid-column: auto;
  }
}

.left {
  width: 50%;
  height: max-content;
}

.content {
  display: flex;
}

.right {
  width: 50%;
  padding-left: 32px;
}

h1 {
  margin-bottom: 24px;
  font-style: normal;
  font-weight: 800;
  font-size: 28px;
  line-height: 130%;
  color: #404247;
}

h2 {
  font-style: normal;
  font-weight: 800;
  font-size: 24px;
  line-height: 130%;
  color: #404247;
  text-align: left;
  margin-top: 32px;
  margin-bottom: 24px;
}

.label {
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 120%;
  color: #404247;
  text-align: left;
  margin-bottom: 6px;
}

.left .title {
  font-style: normal;
  font-weight: 500;
  font-size: 17px;
  line-height: 120%;
  color: #55575c;
  text-align: left;
  margin-bottom: 4px;
}

.left .num {
  font-style: normal;
  font-weight: 800;
  font-size: 36px;
  line-height: 130%;
  color: #404247;
  text-align: left;
}

.alert {
  background: #fef3ec;
  padding: 16px 24px;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.left_text {
  display: flex;
  align-items: center;
}

.left_text .text {
  margin-left: 18px;
}

.mmm_data {
  background: #ffffff;
  border: 1px solid #fee600;
  border-radius: 8px;
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 110%;
  text-align: center;
  color: #2b2d33;
  padding: 7px 17px;
  cursor: pointer;
}

.vback {
  border: 1px solid #c3c4c6;
  padding: 10px;
  border-radius: 10px;
}

.vback:hover {
  cursor: pointer;
}

.ok .text {
  color: #008e7d;
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 120%;
}
.inform {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px;
  background: #ffffff;
  padding: 24px;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.06), 0 8px 24px rgba(0, 0, 0, 0.1);
  border-radius: 16px;
}
.balance.w100p {
  grid-column: 1 / -1;
}

.inform .balance.input .title {
  min-height: 40px;
  display: flex;
  align-items: flex-end;
}

.inform .balance.input :deep(.v-input) {
  width: 100%;
}

.inform .balance.input :deep(.v-input__slot) {
  height: 40px !important;
  min-height: 40px !important;
  border-radius: 8px;
}

.inform .balance.input :deep(input) {
  height: 40px !important;
  line-height: 40px !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  padding-left: 12px !important;
  padding-right: 12px !important;
}

.inform .balance.input :deep(.v-text-field__details) {
  display: none !important;
}

@media (max-width: 1200px) {
  .inform {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 640px) {
  .inform {
    grid-template-columns: 1fr;
  }
}

.inform .balance.input .title {
  height: 40px;
  line-height: 20px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  margin-bottom: 6px;
}

.inform .balance.input :deep(.v-input__slot) {
  height: 40px !important;
  min-height: 40px !important;
  border-radius: 8px;
}
.inform .balance.input :deep(input) {
  height: 40px !important;
  line-height: 40px !important;
  padding: 0 12px !important;
}
.inform .balance.input :deep(.v-text-field__details) {
  display: none !important;
}

.inform {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
@media (max-width: 1200px) {
  .inform {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 640px) {
  .inform {
    grid-template-columns: 1fr;
  }
}

.markup-preview-error {
  color: #de4040;
  font-weight: 500;
}

.markup-preview-summary {
  display: flex;
  flex-wrap: wrap;
  gap: 12px 24px;
  margin-bottom: 0;
}

.markup-preview-trunk {
  padding: 14px 0;
  border-top: 1px solid #e4e7ec;
}

.markup-preview-title {
  margin-bottom: 8px;
  font-weight: 600;
  color: #344054;
}

.markup-preview-number {
  margin-bottom: 10px;
}

.markup-preview-operators {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 12px;
}

.markup-preview-operator {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 12px;
  background: #f7f8fa;
  border-radius: 6px;
}

.markup-preview-operator-title {
  font-weight: 600;
}

.tariff-mode-toggle {
  display: flex;
  width: 100%;
}

.tariff-mode-button {
  flex: 1;
  text-transform: none;
}
.markup-preview-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100px;
  color: #667085;
  font-size: 16px;
  font-weight: 500;
}

.loading-dots {
  display: inline-flex;
  width: 45px;
  margin-left: 3px;
}

.loading-dots span {
  color: #344054;
  font-size: 22px;
  font-weight: 700;
  line-height: 1;
  opacity: 0;
  animation: loading-dot 1.5s infinite;
}

.loading-dots span:nth-child(2) {
  animation-delay: 0.15s;
}

.loading-dots span:nth-child(3) {
  animation-delay: 0.3s;
}

.loading-dots span:nth-child(4) {
  animation-delay: 0.45s;
}

.loading-dots span:nth-child(5) {
  animation-delay: 0.6s;
}

@keyframes loading-dot {
  0%,
  20% {
    opacity: 0;
    transform: translateY(0);
  }

  50% {
    opacity: 1;
    transform: translateY(-3px);
  }

  100% {
    opacity: 0;
    transform: translateY(0);
  }
}
.tariff-individual-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.tariff-individual-label {
  color: #68758a;
  font-size: 13px;
}

.tariff-individual-input {
  background: #ffffff;
  border-radius: 6px;
}
.trunk-tariff-header {
  display: flex;
  align-items: center;
  gap: 10px;
}

.trunk-tariff-name {
  padding: 5px 10px;
  color: #3f4b5f;
  font-weight: 600;
  background: #f1f3f6;
  border: 1px solid #e1e5eb;
  border-radius: 6px;
}

.trunk-tariff-price-label {
  color: #7b8494;
  font-size: 13px;
}

.trunk-tariff-price {
  padding: 4px 8px;
  color: #3f4b5f;
  background: #f1f3f6;
  border: 1px solid #e1e5eb;
  border-radius: 6px;
}
.user-tariffs-actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin: 12px 0 20px;
}

.user-tariffs-save-button {
  min-width: 180px;
  height: 38px !important;
  color: #3f4b5f !important;
  background: #f1f3f6 !important;
  border: 1px solid #e1e5eb !important;
  border-radius: 6px;
  box-shadow: none !important;
  text-transform: none;
  letter-spacing: normal;
}

.user-tariffs-save-button:hover {
  background: #e7eaee !important;
}

.user-tariffs-success {
  color: #2f8f4e;
  font-size: 14px;
}

.user-tariffs-save-error {
  color: #e05252;
  font-size: 14px;
}
.trunk-panel-header--active {
  background: #f5f7f6;
  border-left: 3px solid #66a578;
}

.trunk-active-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 3px 8px;
  color: #52705b;
  background: #e9f1eb;
  border: 1px solid #d4e2d7;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
}

.trunk-active-dot {
  width: 6px;
  height: 6px;
  background: #66a578;
  border-radius: 50%;
}
</style>
